import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#rate-table-personal-loan-v2-app', App);
